/* eslint-disable no-else-return */
import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import { FormattedHTMLMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import Card from '../../components/Card'
import ContentItem from './ContentItem'
import { claimActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import EmailMyRewardsModal from '../../components/Modal/EmailMyRewardsModal/EmailMyRewardsModal'
import ClaimedRewardDateCheckUtil from '../../utilities/claimedRewardDateCheck.util'

class ClaimedReward extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emailModal: false,
      isExpired: null,
    }
  }

  componentDidMount() {
    this.setState({ isExpired: this.checkValidDate() })
  }

  handleRedeem(coupon, redemptionId) {
    const { setSelectState } = this.props
    setSelectState(coupon, redemptionId)
  }

  handleRevealKey = (contentId, partnerId) => {
    const {
      reward: { redemptionId, coupon },
      recordRevealKey,
    } = this.props
    recordRevealKey(redemptionId, coupon, contentId, partnerId)
  }

  checkValidDate = () => {
    const {
      reward: { couponExpiresAt, distributionExpiresAt, dlistExpiresAt },
    } = this.props

    return ClaimedRewardDateCheckUtil.isAnyDateExpired([
      couponExpiresAt,
      distributionExpiresAt,
      dlistExpiresAt,
    ])
  }

  toggleEmailModal = () => {
    const { emailModal } = this.state
    this.setState({ emailModal: !emailModal })
  }

  renderGames() {
    const {
      reward: { contentItems, coupon, creditsAvailable },
      parentKey,
    } = this.props
    const { isExpired } = this.state
    const contentItemsLength = contentItems.length

    if (isExpired && contentItemsLength === 0) {
      return (
        <div className="mb-3">
          <FormattedHTMLMessage id="error.coupon.couponExpiredCredits" />
        </div>
      )
    } else if (contentItemsLength === 0) {
      return (
        <div className="mb-3">
          <FormattedMessage id="page.myRewardsPage.text.noPromotionReward" />
        </div>
      )
    }

    const extraProviders = [...new Set(contentItems.map(contentItem => contentItem.provider))]

    return (
      <div className="mb-4">
        {contentItems.map(contentItem => (
          <ContentItem
            handleReveal={this.handleRevealKey}
            couponCode={coupon}
            contentItem={contentItem}
            key={`${parentKey}-${contentItem.name}`}
            extraProviders={extraProviders}
            creditsAvailable={creditsAvailable}
            isExpired={isExpired}
          />
        ))}
      </div>
    )
  }

  renderRedeemRemainingCreditsButton() {
    const {
      reward: { creditsAvailable, coupon, redemptionId },
    } = this.props
    const { isExpired } = this.state

    if (creditsAvailable > 0 && !isExpired) {
      return (
        <div className="mb-4">
          <NavLink to="/claim-reward">
            <Button
              onClick={() => {
                this.handleRedeem(coupon, redemptionId)
              }}
              color="dark"
              block
              aria-label="Redeem available credits"
            >
              <FormattedMessage
                id="page.myRewardsPage.button.redeemCredit"
                values={{ credits: creditsAvailable }}
              />
            </Button>
          </NavLink>
        </div>
      )
    }
    return false
  }

  renderCreditExpirationDateDisplay() {
    const {
      reward: { couponExpiresAt, distributionExpiresAt, dlistExpiresAt, creditsAvailable },
    } = this.props

    let expirationDate = null
    if (couponExpiresAt) {
      expirationDate = couponExpiresAt
    } else if (dlistExpiresAt) {
      expirationDate = dlistExpiresAt
    } else {
      expirationDate = distributionExpiresAt
    }

    if (expirationDate && creditsAvailable > 0) {
      return (
        <>
          <div className="mb-3">
            <FormattedMessage
              id="global.label.creditExpiration"
              values={{ date: moment(expirationDate).format('YYYY-MM-DD') }}
            />
          </div>
          <div className="mb-3">
            <FormattedMessage id="global.label.creditExpirationFormat" />
          </div>
        </>
      )
    }

    return null
  }

  render() {
    const {
      reward: { creditsUsed, creditsAvailable, coupon },
      email,
      title,
    } = this.props
    const { emailModal } = this.state

    return (
      <div className="my-3">
        <Card>
          <EmailMyRewardsModal isOpen={emailModal} toggle={this.toggleEmailModal} email={email} />
          <div className="row justify-content-between">
            <div className="col">
              <h4>{title}</h4>
              <p>
                <FormattedMessage id="global.label.rewardReference" />
                {` - ${coupon}`}
              </p>
            </div>
            <div className="col-auto align-items-center">
              <div>
                <h6 className="text-right">
                  <FormattedMessage id="page.redemptionPage.text.creditsUsed" />
                  {` ${creditsUsed}`}
                </h6>
                <h6 className="text-right">
                  <FormattedMessage id="page.redemptionPage.text.creditsAvailable" />
                  {` ${creditsAvailable}`}
                </h6>
              </div>
            </div>
          </div>
          {this.renderGames()}
          {this.renderRedeemRemainingCreditsButton()}
          {this.renderCreditExpirationDateDisplay()}
        </Card>
      </div>
    )
  }
}

ClaimedReward.propTypes = {
  reward: PropTypes.object.isRequired,
  parentKey: PropTypes.number,
}

const mapDispatchToProps = dispatch => ({
  setSelectState: (...args) => dispatch(claimActions.setSelectState(...args)),
  emailRedemption: (...args) => dispatch(claimActions.emailRedemption(...args)),
  recordRevealKey: (...args) => dispatch(claimActions.logRevealKey(...args)),
})

export default connect(null, mapDispatchToProps)(ClaimedReward)
